export const enum MutationNames {
  updatePatientWithLiveDataLatests = 'PATIENT_WITH_LIVE_DATA_LATEST_UPDATE_PATIENT_WITH_LIVE_DATA_LATESTS',
  updatePatientWithHistories = 'PATIENT_WITH_LIVE_DATA_LATEST_UPDATE_PATIENT_WITH_HISTORIES',
  resetPatientWitLiveData = 'PATIENT_WITH_LIVE_DATA_LATEST_RESET_PATIENT_WITH_LIVE_DATA',
}

export const enum ActionNames {
  getPatientWithLiveDataLatests = 'PATIENT_WITH_LIVE_DATA_LATEST_GET_PATIENT_WITH_LIVE_DATA_LATESTS',
}

export const enum GetterNames {
  patientWithLiveDataLatests = 'PATIENT_WITH_LIVE_DATA_LATEST_PATIENT_WITH_LIVE_DATA_LATESTS',
}
